import BlotRegistry from '../../components/Lab/BlotRegistry'

/**
 * /lab/registry — le registre d'évaluation des Western blots.
 *
 * Route STATIQUE, déclarée à côté de /lab/:specialtyId : React Router classe
 * les segments littéraux avant les dynamiques, « registry » n'est donc jamais
 * avalé comme un nom de spécialité.
 */
export default function BlotRegistryPage() {
  return <BlotRegistry />
}
